import React, { useEffect, useMemo } from 'react';
import { Grid } from '@mui/material';
import {
  DateInput,
  required,
  SelectInput,
  TimeInput,
  useRecordContext,
} from 'react-admin';
import { useController } from 'react-hook-form';
import { REPEATED_EVENT_FREQUENCY } from '../../../constants';

const FREQUENCY_TO_LABEL = {
  [REPEATED_EVENT_FREQUENCY.everyday]: 'Every day',
  [REPEATED_EVENT_FREQUENCY.everyweek]: 'Every week',
};

export const EventRepeatedDateFields = () => {
  const record = useRecordContext();

  const startDateInput = useController({ name: 'startDate' });

  const startTimeInput = useController({
    name: 'startTime',
    defaultValue: record?.startDate && new Date(record?.startDate),
  });
  const endTimeInput = useController({
    name: 'endTime',
    defaultValue: record?.endDate && new Date(record?.endDate),
  });

  const frequenciesList = useMemo(
    () =>
      Object.values(REPEATED_EVENT_FREQUENCY).map((value) => ({
        id: value,
        name: FREQUENCY_TO_LABEL[value],
      })),
    [],
  );

  const isTimeNotAligned = () => {
    const startDate = startTimeInput.field.value;
    const endDate = endTimeInput.field.value;
    return startDate && endDate && endDate.getTime() < startDate.getTime();
  };

  useEffect(() => {
    if (isTimeNotAligned()) {
      endTimeInput.field.onChange(startTimeInput.field.value);
    }
  }, [startTimeInput.field.value]);

  useEffect(() => {
    if (isTimeNotAligned()) {
      startTimeInput.field.onChange(endTimeInput.field.value);
    }
  }, [endTimeInput.field.value]);

  return (
    <Grid container columnSpacing={2}>
      <Grid item xs={3}>
        <DateInput
          {...startDateInput.field}
          source="startDate"
          label="Start date"
          validate={[required()]}
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <Grid container columnSpacing={2}>
          <Grid item xs={6}>
            <TimeInput
              {...startTimeInput.field}
              source="startTime"
              label="Start time"
              validate={[required()]}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TimeInput
              {...endTimeInput.field}
              source="endTime"
              label="End time"
              validate={[required()]}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={5}>
        <Grid container columnSpacing={2}>
          <Grid item xs={6}>
            <SelectInput
              source="frequency"
              choices={frequenciesList}
              label="Repeated frequency"
              validate={[required()]}
              defaultValue={REPEATED_EVENT_FREQUENCY.everyday}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <DateInput
              source="repeatUntil"
              label="Ending on"
              validate={[required()]}
              fullWidth
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
